module.exports = __webpack_public_path__ + "static/media/ramp-loading.b7330f1f.svg";